import { useQuery } from '@tanstack/react-query';
import { tenantsApi } from '../api/tenants.api';
import { tenantsKeys } from './queryKeys';

export const useTenantDetail = (tenantId: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: tenantsKeys.detail(tenantId),
    queryFn: () => tenantsApi.getTenantDetail(tenantId),
    enabled: !!tenantId,
  });

  return {
    tenant: data?.data ?? null,
    isLoading,
    error,
  };
};
